import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setStatus('success');
      setEmail('');
      setTimeout(() => setStatus('idle'), 3000);
    }
  };

  return (
    <section className="py-24 bg-amber-50">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="flex items-center justify-center mb-4">
          <div className="w-2 h-2 bg-amber-600 rounded-full"></div>
          <span className="text-sm font-medium text-amber-700 ml-2 uppercase tracking-wide">STAY CONNECTED</span>
        </div>
        
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Join the Reader<br />Community
        </h2>
        
        <p className="text-gray-600 text-base leading-relaxed mb-8 max-w-2xl mx-auto">
          Subscribe to receive updates about new releases, upcoming events, exclusive content, and thoughtful reflections on life's important decisions.
        </p>
        
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto mb-8">
          <input 
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            className="flex-1 px-6 py-4 rounded-full border border-gray-300 focus:outline-none focus:border-amber-600 text-sm"
            required
          />
          <button 
            type="submit"
            className="px-8 py-4 bg-amber-700 text-white rounded-full text-sm font-medium hover:bg-amber-800 transition-colors whitespace-nowrap"
          >
            SUBSCRIBE
          </button>
        </form>
        
        {status === 'success' && (
          <p className="text-green-600 text-sm font-medium mb-6">Thank you for subscribing!</p>
        )}
        
        <div className="flex items-center justify-center gap-4">
          <a href="#" className="w-12 h-12 border-2 border-amber-600 rounded-full flex items-center justify-center text-amber-600 hover:bg-amber-600 hover:text-white transition-colors">
            <i className="ri-facebook-fill text-lg"></i>
          </a>
          <a href="#" className="w-12 h-12 border-2 border-amber-600 rounded-full flex items-center justify-center text-amber-600 hover:bg-amber-600 hover:text-white transition-colors">
            <i className="ri-twitter-x-line text-lg"></i>
          </a>
          <a href="#" className="w-12 h-12 border-2 border-amber-600 rounded-full flex items-center justify-center text-amber-600 hover:bg-amber-600 hover:text-white transition-colors">
            <i className="ri-instagram-line text-lg"></i>
          </a>
          <a href="#" className="w-12 h-12 border-2 border-amber-600 rounded-full flex items-center justify-center text-amber-600 hover:bg-amber-600 hover:text-white transition-colors">
            <i className="ri-linkedin-fill text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}